import { render, staticRenderFns } from "./AisleCreate.vue?vue&type=template&id=60713b96&scoped=true"
import script from "./AisleCreate.vue?vue&type=script&lang=js"
export * from "./AisleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60713b96",
  null
  
)

export default component.exports